import { DEFAULT_PAGINATION } from "@/constants/table";
import { PaginationProps } from "antd";
import Table, { FilterOptions } from "@/components/table";
import { useMemo, useState } from "react";
import { getColumns } from "./utils/table";
import {
  useGetExpenseHistoriesOptions,
  useGetExpenseHistoriesPagination,
} from "@/pages/Expenses/RecordExpense/hooks/useExpenses";
import { SortCondition } from "@/components/table/hooks/useSort";
import { FilterCondition } from "@/components/table/hooks/useFilter";

const ExpenseHistory = () => {
  const [sort, setSort] = useState<SortCondition | undefined>({
    field: "created_at",
    order: "desc",
  });
  const [filters, setFilters] = useState<FilterCondition[]>([]);
  const [pagination, setPagination] = useState<PaginationProps>();

  const { data, isLoading } = useGetExpenseHistoriesPagination({
    config: {
      params: {
        include_inactive: false,
        sort: sort ? [{ field: sort.field, order: sort.order }] : undefined,
        filters: filters.length > 0 ? filters : undefined,
        limit: pagination?.pageSize,
        page: pagination?.current,
        offset: ((pagination?.current || 1) - 1) * (pagination?.pageSize || 10),
      },
    },
  });

  // Get filter options
  const { data: options } = useGetExpenseHistoriesOptions({
    params: {
      include_inactive: false,
      only: "expense_type.id,expense_type.name,description.id,description.name,supplier.id,supplier.name,unit.id,unit.name",
      limit: -1,
    },
  });

  const filterOptions = useMemo(
    () => ({
      expense_type_id: (options || []).reduce((acc, item) => {
        if (
          item.expense_type &&
          !acc.some((option) => option.value === item?.expense_type?.id)
        ) {
          acc.push({
            text: item.expense_type.name,
            value: item.expense_type.id,
          });
        }
        return acc;
      }, [] as FilterOptions[]),
      description_id: (options || []).reduce((acc, item) => {
        if (
          item.description &&
          !acc.some((option) => option.value === item?.description?.id)
        ) {
          acc.push({ text: item.description.name, value: item.description.id });
        }
        return acc;
      }, [] as FilterOptions[]),
      supplier_id: (options || []).reduce((acc, item) => {
        if (
          item.supplier &&
          !acc.some((option) => option.value === item?.supplier?.id)
        ) {
          acc.push({ text: item.supplier.name, value: item.supplier.id });
        }
        return acc;
      }, [] as FilterOptions[]),
      unit_id: (options || []).reduce((acc, item) => {
        if (
          item.unit &&
          !acc.some((option) => option.value === item?.unit?.id)
        ) {
          acc.push({ text: item.unit.name, value: item.unit.id });
        }
        return acc;
      }, [] as FilterOptions[]),
    }),
    [options]
  );

  return (
    <>
      <Table
        columns={(props) =>
          getColumns({
            ...props,
            filterOptions,
          })
        }
        dataSource={data?.data || []}
        loading={isLoading}
        pagination={{
          defaultPagination: {
            ...DEFAULT_PAGINATION,
            showSizeChanger: true,
          },
          dataPagination: data?.pagination,
          onChange: setPagination,
        }}
        size="small"
        locale={{
          emptyText: null,
        }}
        scroll={{ x: "max-content" }}
        initialSort={sort}
        onSort={setSort}
        onFilter={setFilters}
        isHidden={
          (!data?.data || data?.data?.length === 0) && filters.length === 0
        }
      />

      {/* TODO: Hide this for now */}
      {/* <ExpenseHistoryDetailModal
        data={viewModalData}
        expenseTypes={expenseTypes}
        isOpen={isViewModalOpen}
        onClose={closeViewModal}
      /> */}
    </>
  );
};

export default ExpenseHistory;
